exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".modal-header {\n  position: relative;\n  margin-bottom: 28px;\n  min-height: 48px;\n  border-bottom: 1px solid #d8d8d8; }\n  .modal-header .header-back {\n    outline: none !important;\n    width: 48px;\n    height: 48px;\n    padding: 0;\n    position: absolute;\n    top: 0;\n    left: 0; }\n  .modal-header .header-title {\n    padding: 10px 60px;\n    text-align: center;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 28px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/ModalHeader/styles.scss
// module id = 1270
// module chunks = 0